import { sharedPathes } from '../shared-routing/pathe'
import { navigateToHome } from './navigateToHome'

export const logout = () => {
  if (window.ReactNativeWebView) {
    navigateToHome()
  } else {
    localStorage.clear()
    window.parent.location.href =
      import.meta.env.VITE_MAIN_WEB_URL + sharedPathes.ON_BOARDING
  }
}
